'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactI18next = require('react-i18next');
require('moment/locale/fr');
require('moment/locale/es');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  speaker: {
    '& .modal-picture-wrapper': {
      '& .modal-picture': {
        height: '5rem',
        width: '5rem',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '8rem',
        margin: '1rem 0 0 2rem'
      }
    },
    '& .modal-bio': {
      padding: '0 2rem',
      '& p': {
        color: '#494949'
      }
    },
    '& .modal-fullname': {
      fontWeight: 'bold',
      padding: '2rem 0 0 2rem',
      color: '#000000'
    }
  }
};
var SpeakerModalContent = function (_Component) {
  _inherits(SpeakerModalContent, _Component);
  function SpeakerModalContent(props) {
    _classCallCheck(this, SpeakerModalContent);
    return _possibleConstructorReturn(this, (SpeakerModalContent.__proto__ || Object.getPrototypeOf(SpeakerModalContent)).call(this, props));
  }
  _createClass(SpeakerModalContent, [{
    key: 'render',
    value: function render() {
      _moment2.default.locale(this.props.i18n.language);
      if (this.props.i18n.language === 'es') _moment2.default.updateLocale('es', {
        ordinal: '%d'
      });
      var _props = this.props,
        classes = _props.classes,
        speaker = _props.speaker,
        imgStyle = _props.imgStyle,
        t = _props.t;
      return _react2.default.createElement('div', {
        className: classes.speaker
      }, !!speaker && _react2.default.createElement('div', {
        className: 'modal-picture-wrapper'
      }, _react2.default.createElement('div', {
        className: 'modal-picture',
        style: imgStyle
      })), !!speaker && !!speaker.fullName && _react2.default.createElement('div', {
        className: 'modal-fullname'
      }, speaker.fullName), !!speaker && !!speaker.bio ? _react2.default.createElement('div', {
        className: 'modal-bio'
      }, _react2.default.createElement('p', {
        dangerouslySetInnerHTML: {
          __html: speaker.bio
        }
      })) : _react2.default.createElement('div', {
        className: 'modal-bio'
      }, _react2.default.createElement('p', null, t('speakers.empty_bio'))));
    }
  }]);
  return SpeakerModalContent;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(SpeakerModalContent));